/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type devices_DeviceResponse = {
    appVersion?: string;
    childcareId: string;
    childcareName?: string;
    /**
     * CodeExpired is true for a pending device whose code can no longer be redeemed.
     */
    codeExpired: boolean;
    /**
     * CodeExpiresAt is set only while the device is pending.
     */
    codeExpiresAt?: string;
    enrolledAt?: string;
    enrolledByName?: string;
    id: string;
    lastSeenAt?: string;
    name: string;
    platform?: devices_DeviceResponse.platform;
    revokedAt?: string;
    status: devices_DeviceResponse.status;
};
export namespace devices_DeviceResponse {
    export enum platform {
        IOS = 'ios',
        ANDROID = 'android',
    }
    export enum status {
        PENDING = 'pending',
        ACTIVE = 'active',
        REVOKED = 'revoked',
    }
}

